function takeWhile(predicate) {
  return function (source) {
    return function (start, sink) {
      if (start !== 0) return;
      var sourceTalkback;
      source(0, function (type, data) {
        if (type === 0) {
          sourceTalkback = data;
        }

        if (type === 1 && !predicate(data)) {
          sourceTalkback(2);
          sink(2);
          return;
        }

        sink(type, data);
      });
    };
  };
}

export default takeWhile;



//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-take-while/dist/callbag-take-while.esm.js
// module id = 633
// module chunks = 0